import React from "react";
import { THEME_DICTIONARY } from "consts";
//
import {
    makeStyles,
    useTheme,
    Tooltip,
    IconButton,
} from "@material-ui/core";
import {
    Brightness4 as Brightness4Icon,
    Brightness7 as Brightness7Icon,
} from "@material-ui/icons";
//
import { SelectedThemeContext } from "theme/themeContext";

const useStyles = makeStyles((theme) => ({
    buttonBorder: {
        border: "1px solid",
        borderColor: theme.palette.text.secondary,
        borderRadius: 12,
        padding: theme.spacing(1),
        width: 40,
        height: 40,
    },
}));

function ThemeSwitchButton() {
    const theme = useTheme();
    const classes = useStyles();

    return (
        <SelectedThemeContext.Consumer>
            {(selectedThemeContext) => (
                <Tooltip title="Toggle light/dark theme">
                    <IconButton
                        onClick={selectedThemeContext.toggleTheme}
                        color="primary"
                        className={classes.buttonBorder}
                    >
                        {theme.palette.type === THEME_DICTIONARY.LIGHT ? <Brightness4Icon /> : <Brightness7Icon />}
                    </IconButton>
                </Tooltip>
            )}
        </SelectedThemeContext.Consumer>
    );
}

export default ThemeSwitchButton;
